let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("i5RZQ")]).then(() => parcelRequire('ib7KB'));